import React, { useEffect, useState } from 'react';
import { generateSharePoster } from '../../utils/sharePoster';

/** The print poster at thumbnail size, drawn by the real renderer. */
export default function PosterThumb({ details, template, poster = null, box = 88 }) {
  const [src, setSrc] = useState(null);
  const { title, dateLabel, venue, city, url, code } = details;
  useEffect(() => {
    let on = true;
    generateSharePoster({ title, dateLabel, venue, city, url, code }, 'poster', template, { poster, scale: 0.12 })
      .then((r) => { if (on) setSrc(r.dataUrl); })
      .catch(() => {});
    return () => { on = false; };
  }, [title, dateLabel, venue, city, url, code, template, poster]);
  return src ? <img src={src} alt="" style={{ position: 'absolute', inset: 0, width: box, height: '100%', objectFit: 'contain' }} /> : null;
}
